import { usePermission, useRole } from '../../rbac/hooks';
import TaskCaseCounselSubTasksTab from './TaskCaseCounselSubTasksTab';
import TaskCaseJuniorSubTasksTab from './TaskCaseJuniorSubTasksTab';
import { isAllocationOfficerUser, shouldUseCounselSubTasksCreateView } from './taskCaseSubTaskAccess';
import type { TaskCaseSubTasksTabProps } from './taskCaseSubTasksTypes';

export type { TaskCaseSubTasksTabProps } from './taskCaseSubTasksTypes';

/** Sub Tasks tab — Counsel create/list, Allocation Officer list, or Junior Counsel assigned view. */
export default function TaskCaseSubTasksTab(props: TaskCaseSubTasksTabProps) {
  const { has, loading } = usePermission();
  const { roleName, roleCode } = useRole();
  const allocationOfficer = isAllocationOfficerUser(roleCode, has, roleName);
  const readOnlyCaseLevelSubTasks = allocationOfficer;
  const showCounselView = shouldUseCounselSubTasksCreateView(
    roleName,
    has('ASSIGN_SUB_TASKS'),
    props.taskType,
    props.isReceivedViaForward,
    roleCode,
    has,
  );

  if (loading) {
    return (
      <>
        <div className="log-title">Sub Tasks</div>
        <p className="tcd-update-ts" style={{ padding: '12px 0', color: 'var(--t2)' }}>
          Loading…
        </p>
      </>
    );
  }

  if (readOnlyCaseLevelSubTasks) {
    return <TaskCaseCounselSubTasksTab {...props} readOnly />;
  }

  if (showCounselView) {
    return <TaskCaseCounselSubTasksTab {...props} />;
  }

  return (
    <TaskCaseJuniorSubTasksTab
      caseRequestId={props.caseRequestId}
      workflowStage={props.workflowStage}
      readOnly={props.readOnly}
    />
  );
}
